import * as AiIcons from "react-icons/ai";
import * as MdIcons from "react-icons/md";
import * as GiIcons from "react-icons/gi";
import * as FaIcons from "react-icons/fa";
import * as RiIcons from "react-icons/ri";

export const NavbarData = [
  {
    name: "Home",
    icon: <AiIcons.AiFillHome size={`2em`} color="white" />,
    url: "/",
  },
  {
    name: "About",
    icon: <FaIcons.FaUserTie size={`2em`} color="white" />,
    url: "/about",
  },
  {
    name: "Skills",
    icon: <GiIcons.GiSkills size={`2em`} color="white" />,
    url: "/skills",
  },
  {
    name: "Projects",
    icon: <AiIcons.AiOutlineFundProjectionScreen size={`2em`} color="white" />,
    url: "/projects",
  },
  {
    name: "Recommendation",
    icon: <MdIcons.MdRecommend size={`2em`} color="white" />,
    url: "/recommendation",
  },
  {
    name: "Open Source",
    icon: <RiIcons.RiOpenSourceLine size={`2em`} color="white" />,
    url: "/open-source-contribution",
  },
  {
    name: "Contact",
    icon: <MdIcons.MdOutlineContactPhone size={`2em`} color="white" />,
    url: "https://nkwetachaterence.netlify.app/",
    target: "_blank",
  },
];
